import React from 'react';
import { motion } from 'framer-motion';
import { FaAward, FaUsers, FaGlobe, FaHandshake } from 'react-icons/fa';
import './AboutSection.css';

const AboutSection = () => {
    const features = [
        {
            icon: <FaAward />,
            title: "Expert Guidance",
            description: "Our experienced counselors provide personalized guidance for your study abroad journey"
        },
        {
            icon: <FaUsers />,
            title: "Student Success",
            description: "500+ students successfully placed in top universities worldwide"
        },
        {
            icon: <FaGlobe />,
            title: "Global Network",
            description: "Partnerships with 50+ prestigious universities across 6 countries"
        },
        {
            icon: <FaHandshake />,
            title: "End-to-End Support",
            description: "From application to visa, we support you every step of the way"
        }
    ];

    return (
        <section className="about-section section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="section-title"
                >
                    <h2>
                        About <span className="gradient-text">SA Visa Consultants</span>
                    </h2>
                    <p>Your trusted partner in achieving global education dreams</p>
                </motion.div>

                <div className="about-content">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="about-text"
                    >
                        <div className="about-image-wrapper">
                            <div className="about-image">
                                <img
                                    src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&q=80"
                                    alt="Students studying abroad"
                                />
                                <div className="image-overlay">
                                    <div className="overlay-content">
                                        <h3 className="gradient-text-accent">10+ Years</h3>
                                        <p>Of Excellence</p>
                                    </div>
                                </div>
                            </div>
                            <div className="floating-badge">
                                <div className="badge-icon"><FaAward /></div>
                                <div className="badge-text">
                                    <strong>Award Winning</strong>
                                    <span>Consultancy</span>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="about-description"
                    >
                        <h3>Empowering Students to Reach Their Global Potential</h3>
                        <p>
                            At SA Visa Consultants, we believe that education knows no boundaries.
                            With over a decade of experience in international education consulting,
                            we have helped hundreds of students realize their dreams of studying abroad.
                        </p>
                        <p>
                            Our team of expert counselors provides comprehensive support throughout
                            your journey - from selecting the right university and program to securing
                            your student visa. We pride ourselves on our personalized approach, ensuring
                            that each student receives guidance tailored to their unique goals and aspirations.
                        </p>

                        <div className="about-stats-grid">
                            <div className="stat-box">
                                <h4 className="gradient-text">98%</h4>
                                <p>Visa Success Rate</p>
                            </div>
                            <div className="stat-box">
                                <h4 className="gradient-text">500+</h4>
                                <p>Students Placed</p>
                            </div>
                            <div className="stat-box">
                                <h4 className="gradient-text">50+</h4>
                                <p>Partner Universities</p>
                            </div>
                            <div className="stat-box">
                                <h4 className="gradient-text">6</h4>
                                <p>Countries</p>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <div className="features-grid">
                    {features.map((feature, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="feature-card card"
                        >
                            <div className="feature-icon">{feature.icon}</div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
